/*
 * Navigation from outside React.
 *
 * Twelve places ask for a route and none of them is a component: sagas after a
 * write, the auth duck on login and logout, the sidebar's click handler, the
 * boot in index.js when /users/me answers 401. React Router 5 handed out a
 * `history` object for exactly this and 7 does not - a data router owns its own
 * history and `useNavigate` only exists inside the tree.
 *
 * What 7 does give is `router.navigate`, on the router object itself. So this
 * stays the module those twelve callers import, with the same `push`, and the
 * router registers itself here once it exists.
 *
 * Registration rather than import, and that is the whole point of the shape:
 * `router.js` has to import the pages, and the pages import this - naming
 * `router.js` from here would close the cycle. The arrow only goes one way.
 */

let router = null;

export const attachRouter = instance => {
  router = instance;
};

const naoHaRouter = to => {
  // Before `router.js` has run there is nothing to navigate. Nothing does this
  // today - every caller runs after the module graph is loaded - and if one ever
  // did, silence would be the wrong answer.
  throw new Error(`navigation to ${to} before the router existed`);
};

export default {
  push: to => (router ? router.navigate(to) : naoHaRouter(to)),
  replace: to => (router ? router.navigate(to, { replace: true }) : naoHaRouter(to)),
};
